import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getAccountId = () => useAuthorizationStore().getAccountSlug

const getDetailWorkspace = (slug) => axios.get(`${getAccountId()}/workspaces/${slug}`)
const createWorkspace = (formData) => axios.post(`${getAccountId()}/workspaces`, formData)
const updateWorkspace = ({ formData, slug }) => axios.patch(`${getAccountId()}/workspaces/${slug}`, formData)
const deleteWorkspace = (slug) => axios.delete(`${getAccountId()}/workspaces/${slug}`)

export {
    getDetailWorkspace, createWorkspace, updateWorkspace, deleteWorkspace,
}
